import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import TimerDisplayV2 from "components/CountdownV2/TimerDisplayV2";
import { Dip } from "interfaces";
import moment from "moment";
import { getCount, getDisplay } from "utils/time";

interface DataOverlayProps {
	nowTime: moment.Moment;
	currentDip: Dip;
	fromHud: boolean;
}

export const DataOverlay = ({
	nowTime,
	currentDip,
	fromHud
}: DataOverlayProps) => {
	const [endTime, setEndTime] = useState("");
	const [timerDisplay, setDisplayTimer] = useState("");

	useEffect(() => {
		const endTime = moment(nowTime)
			.add(currentDip.dip.cooldownMinutes, "minutes")
			.toISOString();
		const eventTimer = getCount(nowTime, endTime);

		setEndTime(endTime);
		setDisplayTimer(getDisplay(eventTimer));
	}, [currentDip]);

	return (
		<Container>
			<span>{`Id: ${currentDip?.dip?.id}`}</span>
			{currentDip?.dip?.maxImpressions && (
				<span>{`Max Impresions: ${currentDip.dip.maxImpressions}`}</span>
			)}
			{typeof currentDip?.viewCount === "number" && (
				<span>{`Impresions: ${
					fromHud ? currentDip.viewCount : currentDip.viewCount + 1
				}`}</span>
			)}
			{currentDip?.dip?.maxRequisitions && (
				<span>{`Max Requisitions: ${currentDip.dip.maxRequisitions}`}</span>
			)}
			{typeof currentDip?.requisitionCount === "number" && (
				<span>{`Requisitions: ${currentDip.requisitionCount}`}</span>
			)}
			<span>{`Max Cooldown: ${timerDisplay}`}</span>
			<span>
				Cooldown:
				{endTime && (
					<TimerDisplayV2
						endTime={endTime}
						startTime={nowTime}
						onEnd={() => {}}
					/>
				)}
			</span>
			<span>{`Trigger Type: ${
				fromHud ? "hud" : currentDip?.dip?.triggerType
			}`}</span>
		</Container>
	);
};
